import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getrmareport } from "../../actions/inventoryAction";
import _ from "lodash";
import { Button, Table, Tag, Input, Select, Avatar } from "antd";
const { Option } = Select;

class RMAReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      marketer: [],
      data: [],
      pagination: {},
      loading: true,
      retailer: [],
      selectedItems: [],
    };
  }

  componentWillMount() {
    this.getdesignation({
      results: 10,
      page: 1,
    });
  }

  getdesignation(params = {}) {
    this.props
      .getrmareport(params)
      .then((res) => {
        console.log(res);
        const pagination = { ...this.state.pagination };
        pagination.total = res.data.items.total;
        this.setState({
          data: res.data.items.data,
          loading: false,
          pagination,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  }
  handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
    });
  };
  fetch = (params = {}) => {
    console.log("params:", params);
    this.getdesignation(params);
  };

  searchMarketer = () => {
    this.setState({ loading: true });
    var status = this.state.status;
    var search_text = this.state.name;
    var retailer = this.state.selectedItems;
    console.log(
      `status: ${status} search_text: ${search_text} retailer: ${retailer}`
    );
    this.props
      .searchibomarket({
        status: status,
        search_text: search_text,

        retailer: retailer,
      })
      .then((res) => {
        console.log(res);
        const pagination = { ...this.state.pagination };
        pagination.total = res.data.items.total;
        this.setState({
          data: res.data.items.data,
          loading: false,
          pagination,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  clearSearch = () => {
    this.setState({ loading: true });
    this.setState({
      status: undefined,
      name: "",
      selectedItems: [],
    });
    this.getdesignation({
      results: 10,
      page: 1,
    });
  };

  renderRetailer() {
    return _.map(this.state.retailer, (master, index) => {
      return (
        <Option value={master.id} key={index}>
          {master.name}
        </Option>
      );
    });
  }
  onchangeRole = (selectedItems) => {
    this.setState({ selectedItems });
    console.log(this.state.selectedItems);
  };
  // ======================================================

  render() {
    const columns = [
      {
        title: "Office Number",
        dataIndex: "office_number",
        key: "office_number",
      },
      {
        title: "Manager",
        dataIndex: "manager_name",
        key: "manager_name",
      },
      {
        title: "Agent",
        dataIndex: "agent_name",
        key: "agent_name",
      },
      {
        title: "IMEI",
        dataIndex: "imei",
        key: "imei",
      },
      {
        title: "Image",
        dataIndex: "device_image_url",
        key: "device_image_url",
        render: (text, record) => (
          <span>
            <Avatar shape="square" size={64} src={record.device_image_url} />
          </span>
        ),
      },
      {
        title: "Comments",
        dataIndex: "reason",
        key: "reason",
      },

      {
        title: "Status",
        key: "status",
        dataIndex: "status",
        render: (text, record) => (
          <span>
            <Tag color={text === 1 ? "orange" : text === 3 ? "red" : "green"}>
              {record.status_text}
            </Tag>
          </span>
        ),
      },
      {
        title: "Created At",
        dataIndex: "created_date",
        key: "created_date",
      },
    ];

    return (
      <div>
        <div className="container-fluid">
          <div className="row padd20 bg-grey">
            <div className="col-sm-4">
              <h4>RMA Report</h4>
            </div>
          </div>

          <div className="bg-white padd0">
            <Table
              columns={columns}
              dataSource={this.state.data}
              scroll={{ x: true }}
              pagination={this.state.pagination}
              loading={this.state.loading}
              onChange={this.handleTableChange}
              // size="small"
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    ibomarket: state.data,
    data: state.data,
  };
}

export default connect(mapStateToProps, {
  getrmareport,
})(RMAReport);
